/* Header Quick Start measurement and demo intent. Never collect form answers. */
(() => {
  'use strict';
  const key = 'tapt_demo_intent_v1';
  const funnelKey = 'tapt_quick_start_funnel_v1';
  const funnelStages = new Set(['landed','submitted','preview_ready','product_selected','cart_submitted','completed','profile_error','cart_error','validation_error']);
  window.taptQuickStartAttribution = () => {
    try {
      const flow = JSON.parse(sessionStorage.getItem(funnelKey) || 'null');
      if (!flow || !/^[a-zA-Z0-9_-]{1,100}$/.test(flow.id) || !Number.isFinite(flow.at) || Date.now() - flow.at < 0 || Date.now() - flow.at > 30 * 60 * 1000) return '';
      return flow.id + ':' + flow.at;
    } catch (_) { return ''; }
  };
  function trackStage(stage) {
    try {
      if (!funnelStages.has(stage)) return;
      const flow = JSON.parse(sessionStorage.getItem(funnelKey) || 'null');
      if (!flow || !/^[a-zA-Z0-9_-]{1,100}$/.test(flow.id) || !Number.isFinite(flow.at) || Date.now() - flow.at < 0 || Date.now() - flow.at > 30 * 60 * 1000) return;
      Promise.resolve(window.Shopify?.analytics?.publish('tapt:quick_start_funnel', {stage, funnel_id:flow.id})).catch(() => {});
    } catch (_) {}
  }
  document.addEventListener('tapt:quick-start-stage', event => trackStage(event.detail?.stage));
  const pendingKey = 'tapt_quick_start_click_v1';
  // Deliver on arrival so navigation cannot destroy a cold analytics sandbox.
  function deliverPending(attempt = 0) {
    try {
      const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (!pending) return;
      if (!/^[a-zA-Z0-9_-]{1,100}$/.test(pending.id) || !Number.isFinite(pending.at) || Date.now() - pending.at < 0 || Date.now() - pending.at > 30000) {
        sessionStorage.removeItem(pendingKey);
        return;
      }
      if (typeof window.Shopify?.analytics?.publish !== 'function') {
        if (attempt < 50) setTimeout(() => deliverPending(attempt + 1), 100);
        return;
      }
      Promise.resolve(window.Shopify.analytics.publish('tapt:quick_start_header_clicked', {click_id:pending.id})).then(() => {
        if (sessionStorage.getItem(pendingKey) === JSON.stringify(pending)) sessionStorage.removeItem(pendingKey);
      }).catch(() => {});
    } catch (_) {}
  }
  deliverPending();
  if (document.querySelector('tapt-linkedin-onboarding')) trackStage('landed');
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link?.matches('.header__quick-start')) {
      let clickId;
      try {
        clickId = window.crypto.randomUUID();
        sessionStorage.setItem(funnelKey, JSON.stringify({id:clickId,at:Date.now()}));
      } catch (_) {}
      const target = new URL(link.href, location.href);
      if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && link.target !== '_blank' && target.origin === location.origin) {
        try {
          sessionStorage.setItem(pendingKey, JSON.stringify({id:clickId || window.crypto.randomUUID(),at:Date.now()}));
          return;
        } catch (_) { /* Storage unavailable: fall back to immediate measurement. */ }
      }
      try {
        Promise.resolve(window.Shopify?.analytics?.publish('tapt:quick_start_header_clicked', {click_id:clickId})).catch(() => {});
      } catch (_) {}
      return;
    }
    if (!link || !/\b(?:book|request|get|schedule)\s+(?:a\s+)?demo\b/i.test(link.textContent)) return;
    const target = new URL(link.href, location.href);
    if (target.origin !== location.origin || !/\/pages\/sales-enquiry\/?$/.test(target.pathname)) return;
    try { sessionStorage.setItem(key, String(Date.now())); } catch (_) {}
    try { window.Shopify?.analytics?.publish('tapt:demo_cta_clicked', {}); } catch (_) {}
  });
  window.taptLeadType = () => {
    try {
      const timestamp = Number(sessionStorage.getItem(key));
      sessionStorage.removeItem(key);
      if (timestamp > 0 && Date.now() - timestamp >= 0 && Date.now() - timestamp < 30 * 60 * 1000) return 'demo_request';
    } catch (_) {}
    return 'sales_enquiry';
  };
})();
